<template>
  <div class="logo-wrapper bg-neutral-100 w-full py-24 px-16">
    <img class="logo-logbit" :src="logo" alt="" />
  </div>
</template>

<script setup>
import logo from 'images/logo.png'
</script>

<style lang="sass">
// Logo Estilos ====================
.logo-wrapper
  position: absolute
  bottom: 0
  left: 0

.logo-logbit
  min-width: 100px
  height: 32px
  object-fit: contain
  clip-path: inset(0px 61px 0px 0px)
  transition: clip-path .2s ease

.sidebar-active,
.sidebar-open
  .logo-logbit
    clip-path: inset(0px 0px 0px 0px)
</style>
